require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-familymovies-moviefamilies.json") })
        }
      }, "path---projects-familymovies-moviefamilies");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-familymovies-moviefamilies!./.cache/json/projects-familymovies-moviefamilies.json
// module id = 343
// module chunks = 231608221292675